







































































import { namespace } from 'vuex-class';
import { Vue, Component } from 'vue-property-decorator';
import { AcgnPop } from '@acgn/herm/src/ui';

const authAction = namespace('desk/auth').Action;
const authMutation = namespace('desk/auth').Mutation;

const authGetter = namespace('desk/auth').Getter;

interface LoginType { // 登录类型
  account?: string; // 用户名
  pass?: string; // 密码
}

@Component({
  components: {
    AcgnPop
  }
})
export default class Login extends Vue {

  @authAction private login: any; // 登录
  @authAction private scanLogin: any; // 登录
  @authMutation private setUserDepartInfo: any; // 更新用户信息
  @authAction private changeUserDept: any; // 切换用户所在的二级部门

  @authGetter private loadings: any; // 登录loading

  private dingCode: string = ''; // 钉钉回调码
  private formData: LoginType = {
    // account: 'test',
    // pass: 'test'
  };

  private departs = [
    // {
    //   id: 1,
    //   dept_name: '漫客文化挤满漫客文化挤满'
    // }, {
    //   id: 2,
    //   dept_name: '漫客文化挤满'
    // }, {
    //   id: 3,
    //   dept_name: '漫客文化挤满'
    // }, {
    //   id: 4,
    //   dept_name: '漫客文化挤满'
    // }, {
    //   id: 5,
    //   dept_name: '漫客文化挤满'
    // }, {
    //   id: 6,
    //   dept_name: '漫客文化挤满'
    // }, {
    //   id: 7,
    //   dept_name: '漫客文化挤满'
    // }, {
    //   id: 8,
    //   dept_name: '漫客文化挤满'
    // }, {
    //   id: 9,
    //   dept_name: '漫客文化挤满'
    // }, {
    //   id: 10,
    //   dept_name: '漫客文化挤满'
    // }, {
    //   id: 11,
    //   dept_name: '漫客文化挤满'
    // }, {
    //   id: 12,
    //   dept_name: '漫客文化挤满'
    // }, {
    //   id: 13,
    //   dept_name: '漫客文化挤满'
    // }, {
    //   id: 14,
    //   dept_name: '漫客文化挤满'
    // }, {
    //   id: 15,
    //   dept_name: '漫客文化挤满'
    // }, {
    //   id: 16,
    //   dept_name: '漫客文化挤满'
    // }
  ];
  private isScan: boolean = true; // 默认扫码登录
  private selectDepart: any = {};
  private visible = false;

  // 获取表单验证规则
  private get rules() {
    const rules = {
      account: [
        { required: true, message: '请输入钉钉手机号', trigger: 'blur' }
      ],
      pass: [
        { required: true, message: '请输入密码', trigger: 'blur' }
      ]
    };
    return rules;
  }

  private mounted() {
    this.loginCheck();
    this.loadDing();
  }

  private switchScan(flag: boolean) {
    this.isScan = flag;
  }

  private async fireLogin() {
    try {
      const { result } = await this.scanLogin({ ... this.formData, dingCode: this.dingCode });
      this.departs = result.departments;
      this.selectDepart = result.now_dept;
      if (this.departs.length === 1) {
        this.doIn();
        return;
      }
      this.visible = true;
    } catch (ex) {
      this.$message.error(ex.message);
    }
  }

  private doIn() {
    this.$router.replace('/desk');
  }

  private async departCli(item: any) {
    this.selectDepart = item;
    await this.changeUserDept({ dept_id: item.id });
    this.setUserDepartInfo(item);
  }

  private loginCheck() {
    const { code, path } = this.$route.query;
    if (!code) {
      return;
    }

    this.dingCode = code;
    this.$router.replace({ path });
    this.fireLogin();
  }

  private loadDing() {
    const url = `${window.location.protocol}//${window.location.host}/login`;
    const norGo = `https://oapi.dingtalk.com/connect/oauth2/sns_authorize?appid=${(window as any).configs.dingAppId}&response_type=code&scope=snsapi_login&redirect_uri=${url}`;
    const goto = encodeURIComponent(norGo);

    // @ts-ignore
    DDLogin({
      id: 'login_container',
      goto,
      style: 'border:none;background-color:#FFFFFF;',
      width: '260',
      height: '300'
    });

    const handleMessage = (event: any) => {
      const origin = event.origin;
      if (origin !== 'https://login.dingtalk.com') { // 判断是否来自ddLogin扫码事件。
        return;
      }
      const dingCode = event.data;
      if (!dingCode) {
        return;
      }
      const herf = `${norGo}&loginTmpCode=${dingCode}`;
      window.location.href = herf;
    };
    (window as any).addEventListener('message', handleMessage, false);
  }

  // 登录
  private submit() {
    (this.$refs.form as any).validate(async (valid: boolean) => {
      if (!valid) {
        return;
      }
      this.fireLogin();
    });
  }
}
